<template>
  <div>
    <loader class="imageLoader" :loading="loading" />
    <div class="tab__Item">
      <div class="tab__Content">
        <table class="postsTable" v-if="resources.length > 0">
          <thead>
            <tr>
              <th>Name</th>
            </tr>
          </thead>
          <tbody>
            <website
              v-for="(item, index) in resources"
              :key="item.id"
              :item="item"
              :index="index"
              :websites="org ? org.websites : null"
              :allowSubscription="allowSubscription"
              :subscriptions="subscriptions"
              @subscribe="checkSubscribe(item, $event)"
            ></website>
          </tbody>
        </table>

        <div class="error" v-else-if="errors.length > 0">
          <p>Something went wrong! Please let our administrators know of the problems below.</p>

          <pre>{{ errors }}</pre>
        </div>

        <div class="error" v-else-if="resources.length === 0 && loading === false">
          <p>Sorry, no website matched your criteria.</p>
        </div>
      </div>
    </div>

    <transition name="fade">
      <router-view :queryParams="searchParams" v-if="loading === false"></router-view>
    </transition>
  </div>
</template>

<script>
import Website from '@/components/listing/Website.vue'
import Loader from '@/components/partials/Loader.vue'

export default {
  props: ['filters', 'org', 'allowSubscription'],
  name: 'Websites',
  components: {
    Website,
    Loader,
  },
  data() {
    return {
      searchParams: {
        search_query: '',
      },
      subscriptions: [],
      loading: false,
      queryParams: '',
      errors: '',
    }
  },
  created() {
    if (this.$route.params.id === undefined) {
      this.pushRoute()
    }
  },
  mounted() {
    this.loading = true
    this.$store.dispatch('loadWebsites').then(() => {
      this.loading = false
    })

    if (this.allowSubscription === true) this.subscriptions = this.org.websites.map((website) => website.api_key)
  },
  computed: {
    // Filter resources based on selected filters and search
    resources() {
      const param = this.searchParams
      const websites = this.websites.filter(function (a) {
        return a.url.toLowerCase().includes(param.search_query.toLowerCase())
      })
      return websites
    },
    websites() {
      return this.$store.state.websites.list
    },
  },
  watch: {
    searchParams: {
      deep: true,
      handler() {
        this.selected = []
      },
    },
    subscriptions() {
      this.$emit('input', this.subscriptions)
    },
  },
  methods: {
    // Push search params to route query
    pushRoute() {
      this.selected = []
      this.$router.push({ query: { search: JSON.stringify(this.searchParams) } })
    },
    search() {
      this.searchParams.search_query = this.filters.search_query
      this.pushRoute()
    },
    checkSubscribe(item, val) {
      const index = this.subscriptions.indexOf(item.api_key)

      if (val === true && this.subscriptions.indexOf(item.api_key) === -1) {
        this.subscriptions.push(item.api_key)
      } else {
        this.subscriptions.splice(index, 1)
      }
    },
  },
}
</script>
